import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
const faqs = [{
  question: '¿Por qué cobrar solo $295 por algo que otros cobran $1,500?',
  answer: 'Creemos en el poder de los negocios locales de Chicago. Hemos optimizado nuestro proceso para entregar Conversion Landers de alta calidad sin los costos inflados de las grandes agencias de Downtown. Es un precio justo para un impulso real.'
}, {
  question: '¿Cuánto tiempo tarda en estar lista mi web?',
  answer: 'Rapidez es nuestra prioridad. Una vez que nos entregas la información básica (fotos y servicios), tu sitio estará activo y captando clientes en 7 días hábiles o menos.'
}, {
  question: '¿Tengo que pagar una mensualidad?',
  answer: 'El diseño de $295 es un pago único. Para que tu web siga activa y segura en la nube (hosting), ofrecemos un plan de mantenimiento de solo $25/mes, que incluye el soporte técnico de nuestro equipo en Chicago.'
}, {
  question: '¿Qué pasa si no tengo fotos profesionales?',
  answer: 'No te preocupes. Podemos usar las fotos de tu Instagram actual o seleccionar imágenes de alta calidad que representen tu industria. Nuestro objetivo es que tu negocio se vea de élite desde el primer día.'
}, {
  question: '¿Cómo me contactarán los clientes?',
  answer: 'Tu Conversion Lander tendrá botones directos a tu WhatsApp, Teléfono y Google Maps. El cliente solo tiene que dar un toque con el pulgar para estar hablando contigo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 md:py-32 bg-[#1A1A1A] relative border-t border-brand-gold/10" data-id="element-1">
      <div className="max-w-3xl mx-auto px-4 flex flex-col items-center" data-id="element-2">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-3">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-4">
            <span className="text-gradient-gold" data-id="element-5">Preguntas Frecuentes</span>
          </h2>
        </motion.div>

        <div className="w-full space-y-2 mb-16" data-id="element-6">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} className="border-b border-white/10 last:border-0" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-7">
                <button onClick={() => toggleFAQ(index)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" aria-expanded={isOpen} data-id="element-8">
                  <span className="text-brand-gold font-bold text-lg pr-8" data-id="element-9">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: isOpen ? 45 : 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="flex-shrink-0 text-brand-gold" data-id="element-10">
                    <Plus className="w-6 h-6" data-id="element-11" />
                  </motion.div>
                </button>

                <AnimatePresence initial={false} data-id="element-12">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-13">
                      <p className="pb-6 text-white leading-relaxed" data-id="element-14">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        <motion.div className="flex flex-col items-center w-full" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-15">
          <motion.a href="https://wa.me/447311754270" target="_blank" rel="noopener noreferrer" className="bg-gradient-gold text-brand-black font-bold text-lg px-10 py-4 rounded-full shadow-[0_0_20px_rgba(212,175,55,0.4)] hover:shadow-[0_0_30px_rgba(212,175,55,0.6)] transition-shadow duration-300 inline-block mb-8 text-center w-full sm:w-auto" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} data-id="element-16">
            ¿Tienes otra duda? Chatea con nosotros
          </motion.a>

          <p className="text-gray-500 text-sm italic text-center max-w-xl" data-id="element-17">
            Nota: Solo aceptamos 5 nuevos proyectos por mes para garantizar la
            calidad y atención personalizada que cada negocio en Chicago merece.
          </p>
        </motion.div>
      </div>
    </section>;
}